import { Attr, BelongsTo, Model } from "spraypaint";

import { ApplicationRecord } from "shared/services/spraypaint";
import { type ResourceContactType } from "shared/types/outreach";

import type ContactList from "./ContactList";

@Model()
class ContactListsContact extends ApplicationRecord {
  static jsonapiType = "contact_lists_contacts";

  @Attr() avatarUrl: string;

  @BelongsTo() contact: ResourceContactType;

  @Attr() contactId: string;

  @BelongsTo() contactList: ContactList;

  @Attr() contactListId: string;

  @Attr() contactType: string;

  @Attr({ persist: false }) createdAt: string;

  @Attr({ persist: false }) updatedAt: string;
}

export default ContactListsContact;
